export default {
  personalProfile: "Ficha personal",
  myAccount: "Mi cuenta",
  back_to_my_account: "Volver a mi cuenta",
};
